const STAGE_PORTAL_HOST = /^app\.stage\.[a-z0-9.-]+$/;
const PRODUCTION_PORTAL_HOST = /^app\.[a-z0-9.-]+$/;
const LOCAL_HOSTS = ['localhost', '127.0.0.1'];

/**
 * Runtime guard on top of the per-build measurement id: a production build only tags
 * app.* (never app.stage.*), any other build only tags app.stage.* or localhost.
 * Funnels (www.*) and unrelated domains never load GA4.
 */
export function isGa4AllowedHost(hostname: string, measurementId: string | undefined, isProductionBuild: boolean): boolean {
  if (!measurementId) return false;

  const host = (hostname ?? '').trim().toLowerCase();
  if (STAGE_PORTAL_HOST.test(host)) return !isProductionBuild;
  if (PRODUCTION_PORTAL_HOST.test(host)) return isProductionBuild;
  return !isProductionBuild && LOCAL_HOSTS.includes(host);
}
